
import React, { useContext } from 'react';
import { useCostEstimator } from '@/context/CostEstimatorContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { BaseUrlContext } from './web-components/utils/renderer/contexts';
import SelectedOptions from './summary/SelectedOptions';
import CostBreakdown from './summary/CostBreakdown';
import ActionButtons from './summary/ActionButtons';

const SummaryStep: React.FC = () => {
  const { options, costs, goToPreviousStep } = useCostEstimator();
  const baseUrl = useContext(BaseUrlContext);

  // Log the baseUrl for debugging
  console.log('SummaryStep using baseUrl:', baseUrl || 'No baseUrl provided');

  // Convert maintenance from string to number if it exists
  const maintenanceValue = options.maintenance ? parseInt(options.maintenance) : undefined;

  return (
    <Card className="form-card">
      <CardHeader>
        <CardTitle>Your Project Estimate</CardTitle>
        <CardDescription>Here's a breakdown of your estimated project costs</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <SelectedOptions 
            platforms={options.platforms}
            appType={options.appType}
            features={options.features}
            userVolume={options.userVolume}
            maintenance={maintenanceValue}
          />
          
          <Separator className="my-4" />
          
          <CostBreakdown costs={costs} />
        </div>
      </CardContent>
      <CardFooter>
        <ActionButtons goToPreviousStep={goToPreviousStep} />
      </CardFooter>
    </Card>
  );
};

export default SummaryStep;
